/* Chat: streamed conversations with branching, queueing, side chats, widgets, compare and Heavy modes,
   context management and history (API: api/src/modules/chat/README.md).
   Merged into Ask (features/ask): this descriptor is hidden, its route redirects into Ask, and the screen in
   this folder is what Ask shows for a conversation. The capabilities stay declared here because the code
   that renders them is in this folder. */
import { lazy } from 'react';
import { MessageSquare } from 'lucide-react';
import { defineFeature } from '../../app/feature';

export default defineFeature({
  id: 'chat',
  title: 'Chat',
  short: 'Chat',
  icon: MessageSquare,
  group: 'Work',
  route: '/chat',
  order: 1,
  hidden: true,
  screen: lazy(() => import('../ask/AskRedirect.tsx')),
  capabilities: [
    'CHAT-01', 'CHAT-02', 'CHAT-03', 'CHAT-04', 'CHAT-05', 'CHAT-06', 'CHAT-07', 'CHAT-08',
    'MODEL-02', 'MODEL-03', 'MODEL-04', 'MODEL-05', 'MODEL-06', 'MODEL-07',
    'SEARCH-04', 'SAFE-01', 'SAFE-03', 'MEM-01',
  ],
});
